import { axiosApi } from 'shared/api/axios'
import { CounterpartiesEndpoint } from 'entities/counterparties/api/constant'
import { UpdateContactRequestDTO } from 'entities/counterparties/model/dtoTypes'

export const updateContactToCounterparty = async (body: UpdateContactRequestDTO) => {
    try {
        await axiosApi.patch(CounterpartiesEndpoint.contact, body)
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка')
    }
}
